import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const PendingScreenLayer = ({ title }) => {
  return (
    <div className='card h-100'>
      <div className='card-body d-flex flex-column align-items-center justify-content-center text-center py-80'>
        <span className='w-64-px h-64-px bg-primary-50 text-primary-600 rounded-circle d-flex justify-content-center align-items-center mb-16'>
          <Icon icon='solar:widget-outline' className='text-2xl' />
        </span>
        <h6 className='mb-8'>{title}</h6>
        <p className='text-secondary-light mb-0'>
          Este ecrã ainda está por desenhar. Será construído numa das próximas fases.
        </p>
      </div>
    </div>
  );
};

export default PendingScreenLayer;
